import React, { useEffect, useState } from "react";
import { Popover, TextField, Button, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useTheme } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MdAddCircleOutline, MdOutlineChangeCircle } from "react-icons/md";
import dayjs, { Dayjs } from "dayjs";
import 'dayjs/locale/pt-br';

// Configure dayjs to use pt-BR locale
dayjs.locale('pt-br');

const InputCalendar = ({ onSubmit, onChange, defaultValue }: { onSubmit?: (date: any) => void, onChange?: (date: any) => void, defaultValue?: string }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const theme = useTheme();

  useEffect(() => {
    if (defaultValue) {
      setSelectedDate(dayjs(defaultValue, 'DD/MM/YYYY'));
    }
  }, [defaultValue]);

  const handleOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSave = () => {
    if (selectedDate) {
      const formattedDate = dayjs(selectedDate).format('DD/MM/YYYY');
      onSubmit?.(formattedDate);
    }
    handleClose();
  };

  const handleDateChange = (newValue: any) => {
    setSelectedDate(newValue);
    if (newValue) {
      const formattedDate = dayjs(newValue).format('DD/MM/YYYY');
      onChange?.(formattedDate);
    } else {
      onChange?.(null);
    }
  };

  return (
    <>    
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
        <DatePicker
          value={selectedDate}
          onChange={handleDateChange}
          format="DD/MM/YYYY"
          slotProps={{
            textField: {
              fullWidth: true, 
              size: "small",
              inputProps: {
                style: {
                  height: "35px", // Ajusta a altura do campo do input
                  padding: "10px", // Ajuste do padding do campo do input
                },
              },
            },
          }}
        />
      </LocalizationProvider>
    </>
  );
};

export default InputCalendar;
